import { Tabs } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const FormTab = ({
  getChildContainers,
  getChildFields,
  renderContainer,
  renderField,
  tabs,
  form,
  ...props
}) => {
  const { t: translate } = useTranslation();
  const visibleTabs = tabs?.tab.filter((tab) => {
    // console.log(tab, tab.showTab ? tab.showTab() : true);
    if (!tab.showTab) return true;
    if (!_.isFunction(tab.showTab)) return true;
    return tab.showTab(form.values, form.accessRight);
  });
  const [activeTab, setActiveTab] = useState(
    tabs?.props?.defaultValue || visibleTabs?.[0]?.label
  );

  useEffect(() => {
    const handler = (event) => {
      if (event.detail?.tabsKey && event.detail.tabsKey !== tabs?.key) return;
      if (event.detail?.value) setActiveTab(event.detail.value);
    };
    window.addEventListener("mbid:open-form-tab", handler);
    return () => window.removeEventListener("mbid:open-form-tab", handler);
  }, [tabs?.key]);

  return (
    <>
      <Tabs
        {...tabs.props}
        key={tabs.key}
        value={activeTab}
        onTabChange={setActiveTab}
      >
        <Tabs.List>
          {visibleTabs?.map(({ label, key, iconSize = 14, ...t }) => (
            <Tabs.Tab
              key={key}
              // icon={<t.icon size={iconSize}/>}
              value={label}
            >
              {translate(label)}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {tabs.tab?.map(({ label, key }, index) => (
          <Tabs.Panel key={key} value={label} pt={"xl"}>
            {getChildContainers(key).map((c) => renderContainer(c))}
            {getChildFields(key).map((f) => renderField(f))}
          </Tabs.Panel>
        ))}
      </Tabs>
    </>
  );
};

export default FormTab;
